/* src/app/modules/spare-parts/spare-parts-panel/spare-parts-panel.component.scss */
:host {
  display: block;
  min-width: 20rem;
}
api-call-gate {
  width: 100%;
}
sh-empty-state {
  height: 15.75rem;
  margin-top: -0.5rem;
}
/*# sourceMappingURL=spare-parts-panel.component.css.map */
